import React, { useMemo, useState } from "react";
import { downloadJson } from "./api.js";

export default function JsonReceipt({
  value,
  filename = "rosetta-receipt.json",
  label = "Complete JSON receipt",
  open = false,
  className = "",
}) {
  const text = useMemo(() => JSON.stringify(value, null, 2), [value]);
  const [message, setMessage] = useState("");
  async function copy() {
    try {
      await navigator.clipboard.writeText(text);
      setMessage("Copied entire JSON receipt.");
    } catch {
      setMessage(
        "Clipboard access was unavailable. The complete JSON is selected below.",
      );
    }
  }
  return (
    <details className={`panel json-receipt ${className}`.trim()} open={open}>
      <summary>{label}</summary>
      <div className="page-actions">
        <button className="button" type="button" onClick={copy}>
          Copy entire JSON
        </button>
        <button
          className="button"
          type="button"
          onClick={() => downloadJson(filename, value)}
        >
          Download JSON
        </button>
        <span className="copy-status" role="status">
          {message}
        </span>
      </div>
      <textarea
        aria-label={label}
        readOnly
        spellCheck="false"
        value={text}
        rows={18}
        onFocus={(event) => event.target.select()}
        onClick={(event) => event.target.select()}
      />
    </details>
  );
}
